import { Controller } from "@hotwired/stimulus"

// Cercador del modal d'alta de productors: a cada pulsació (amb debounce) demana
// al servidor el fragment HTML de resultats i l'injecta. Els botons "Afegeix"
// retornats són button_to (amb CSRF), que Turbo gestiona i refresca la pàgina.
//
// Ús:
//   <div data-controller="producer-picker" data-producer-picker-url-value="<%= available_producers_entity_path(@entity) %>">
//     <input data-producer-picker-target="input" data-action="input->producer-picker#search">
//     <div data-producer-picker-target="results"></div>
//   </div>
export default class extends Controller {
  static targets = ["input", "results"]
  static values = {
    url: String,
    minChars: { type: Number, default: 2 },
    prompt: { type: String, default: "Escriu un NIF o nom per cercar productors." }
  }

  connect() {
    this.renderPrompt()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  search() {
    clearTimeout(this.timer)
    const term = this.inputTarget.value.trim()

    if (term.length < this.minCharsValue) {
      this.renderPrompt()
      return
    }

    this.timer = setTimeout(() => this.fetchResults(term), 250)
  }

  async fetchResults(term) {
    try {
      const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(term)}`, {
        headers: { Accept: "text/html" }
      })
      this.resultsTarget.innerHTML = await response.text()
    } catch {
      this.resultsTarget.innerHTML =
        '<p class="px-3 py-6 text-center text-sm text-muted-foreground-1">No s\'ha pogut carregar la cerca.</p>'
    }
  }

  renderPrompt() {
    this.resultsTarget.innerHTML =
      `<p class="px-3 py-6 text-center text-sm text-muted-foreground-1">${this.promptValue}</p>`
  }
}
